export default __webpack_public_path__ + "static/DEIPage-pattern-large-darkpurple-033e467161caa2735f7ef38da6b75773.png";